<template>
  <div
    class="flex items-center justify-center promo-block-mobile"
    :style="{
      height: '81px',
    }"
  >
    <div class="text-center">
      <div class="flex items-center flex-col text-white text-sm font-bold leading-4">
        <div class="uppercase">
          <i
            class="text-xs text-white fa-solid fa-gift mr-2"
          />
          <span>January Sale! Save $50 today</span>
        </div>
        <a
          href="/pricing/"
          class="inline-flex items-center px-5 mt-2 border border-white rounded-full"
          style="height: 28px;"
        >
          <span
            class="text-xs font-bold text-white"
          >
            {{ cta }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    cta() {
      if (['free', 'visitor'].includes(this.$store.getters.userType)) {
        return 'Save Now';
      }
      return 'Upgrade Now';
    },
  },
};
</script>

<style scoped>
.promo-block-mobile {
  background:url('/assets/images/site/home/bg-holiday-mobile.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>

<style>
body.overflow-hidden .promo-block-mobile {
  display: none;
}
</style>
